import { getClient } from '@api/client';
import { AddressInput } from '@api/generated/graphql';
import extractErrorMessage from '@lib/utils/extractErrorMessage';
import { updateUserMutation } from '@pages/settings/UserManagementPage/UserDetailsDrawer/queries/updateUser';

async function updateUserE911Address(
  userId: string,
  e911Address: AddressInput,
) {
  try {
    const { data } = await getClient().mutate({
      mutation: updateUserMutation,
      variables: { userId, e911Address },
    });

    if (!data?.updateUser) {
      throw new Error('No data');
    }

    return data.updateUser;
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
}

export default updateUserE911Address;
